import fs from 'node:fs';
import path from 'node:path';
import type { Database } from 'node-sqlite3-wasm';
import { getPromptQueuesDirectory } from '../../prompt-turn-queue/paths.js';
import { moveLegacyFileToOldVersionBackup } from './archive-to-old-version.js';
import { parsePersistedQueueFromJson } from './parse-persisted-queue-json.js';

/** Import per-queue JSON from the legacy queues directory into `prompt_queue`, then archive each file. */
export function importLegacyPromptQueuesFromDisk(db: Database): void {
  try {
    const dir = getPromptQueuesDirectory();
    if (!fs.existsSync(dir)) return;
    for (const name of fs.readdirSync(dir)) {
      if (!name.endsWith('.json')) continue;
      const full = path.join(dir, name);
      let raw: string;
      try {
        raw = fs.readFileSync(full, 'utf8');
      } catch {
        continue;
      }
      const file = parsePersistedQueueFromJson(raw);
      if (!file) continue;
      db.run(
        `INSERT OR REPLACE INTO prompt_queue (queue_key, updated_at, turns_json) VALUES (?, ?, ?)`,
        [file.queueKey, file.updatedAt, JSON.stringify(file.turns)],
      );
      try {
        moveLegacyFileToOldVersionBackup('queues', full);
      } catch {
        /* ignore */
      }
    }
  } catch (e) {
    console.error('[cli-sqlite] legacy import: prompt queues from disk failed', e);
  }
}
